import { Typography, Grid } from "@material-ui/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";
import { Alert } from "@material-ui/lab";

const LanguageForm = ({
  config,
  setConfig,
  confOptions,
  listLangs,
  setListLangs,
  setErrorLangs,
  errorLangs,
  readOnly = false,
  isEmtProgram = false,
}) => {
  const { t } = useTranslation();

  const isDisabled = readOnly || isEmtProgram;

  const handleCombinationChange = (event) => {
    if (isDisabled) return;

    var filter = confOptions?.combinations?.filter((x) => x.name === event.target.value);

    if (filter.length > 0) {
      setListLangs(filter[0].list);

      setConfig({
        ...config,
        device_setting: {
          ...config?.device_setting,
          langs: {
            ...config.device_setting.langs,
            list: filter[0].list,
            combination: event.target.value,
          },
        },
      });
    }
  };

  const listLanguagesOpts = (listLangs) => {
    return ["00_XX"].concat(listLangs);
  };

  useEffect(() => {
    checkRepeatedLang();
  }, [config.device_setting.langs]);

  const checkRepeatedLang = () => {
    if (
      !isEmtProgram &&
      config?.device_setting?.langs.multifunction_btn === 1 &&
      (
        (
          config?.device_setting?.langs?.langaugeOpt?.lang1 !== 0 &&
          config?.device_setting?.langs?.langaugeOpt?.lang2 !== 0 &&
          config?.device_setting?.langs?.langaugeOpt?.lang1 === config?.device_setting?.langs?.langaugeOpt?.lang2
        ) ||
        config?.device_setting?.langs?.langaugeOpt?.lang2 === config?.device_setting?.langs?.default_lang ||
        config?.device_setting?.langs?.langaugeOpt?.lang1 === config?.device_setting?.langs?.default_lang
      )
    ) {
      setErrorLangs(true);
    } else {
      setErrorLangs(false);
    }
  };

  const onLangChange = (e, key) => {
    if (isDisabled) return;

    const newValue = e.target.value;

    setConfig((prevConfig) => {
      const newLangs = { ...prevConfig.device_setting.langs };
      const newLangOpt = { ...newLangs.langaugeOpt };

      if (key === "default_lang") {
        newLangs.default_lang = newValue;
      } else {
        newLangOpt[key] = newValue;

        if (key === "lang1" && newValue === 0) {
          newLangOpt.lang2 = 0;
        }
      }

      return {
        ...prevConfig,
        device_setting: {
          ...prevConfig.device_setting,
          langs: {
            ...newLangs,
            langaugeOpt: newLangOpt,
          },
        },
      };
    });
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography
          color="secondary"
          style={{
            fontWeight: 500,
            fontSize: 22,
            lineHeight: "30px",
            marginTop: 18,
          }}
        >
          {t("common.languaje")}
        </Typography>
      </Grid>

      {!isEmtProgram && (
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
          <SelectConfig
            label={t("common.lang_combination")}
            value={config?.device_setting?.langs?.combination}
            onChange={handleCombinationChange}
            disabled={isDisabled}
            kv
            values={confOptions?.combinations.map((v) => {
              return { key: v.name, value: v.name.toUpperCase() };
            })}
          />
        </Grid>
      )}

      <Grid
        item
        xl={isEmtProgram  ? 4 : 6}
        lg={isEmtProgram  ? 4 : 6}
        md={isEmtProgram  ? 4 : 6}
        sm={12}
        xs={12}
      >
        <SelectConfig
          error={errorLangs}
          label={t("common.languaje")}
          value={config?.device_setting?.langs?.default_lang}
          onChange={(e) => onLangChange(e, "default_lang")}
          disabled={isDisabled}
          kv
          values={
            isEmtProgram
              ? listLangs
                  ?.filter((v, i) => i + 1 === config?.device_setting?.langs?.default_lang)
                  ?.map((v) => ({
                    key: config?.device_setting?.langs?.default_lang,
                    value: t("common.lang." + v),
                  }))
              : listLangs?.map((v, i) => ({
                  key: i + 1,
                  value: t("common.lang." + v),
                }))
          }
        />
      </Grid>

      {!isEmtProgram &&
        !!config?.device_setting?.langs.multifunction_btn &&
        config?.device_setting?.langs.multifunction_btn === 1 && (
          <>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <SelectConfig
                error={errorLangs}
                label={t("devices.setUp.languageOpt.Lang1")}
                value={config?.device_setting?.langs?.langaugeOpt?.lang1}
                onChange={(e) => onLangChange(e, "lang1")}
                disabled={readOnly}
                kv
                values={listLanguagesOpts(listLangs)?.map((v, i) => {
                  return { key: i, value: t("common.lang." + v) };
                })}
              />
            </Grid>

            {config?.device_setting?.langs?.langaugeOpt?.lang1 !== 0 && (
              <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <SelectConfig
                  error={errorLangs}
                  label={t("devices.setUp.languageOpt.Lang2")}
                  value={config?.device_setting?.langs?.langaugeOpt?.lang2}
                  onChange={(e) => onLangChange(e, "lang2")}
                  disabled={readOnly}
                  kv
                  values={listLanguagesOpts(listLangs)?.map((v, i) => {
                    return { key: i, value: t("common.lang." + v) };
                  })}
                />
              </Grid>
            )}

            {errorLangs ? (
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Alert severity="error">{t("devices.setUp.languageOpt.error")}</Alert>
              </Grid>
            ) : (
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Alert severity="info">{t("devices.setUp.languageOpt.note")}</Alert>
              </Grid>
            )}
          </>
        )}
    </>
  );
};

export default LanguageForm;